import React from 'react'
import { useConfig } from 'hooks/use-config'
import { cn } from 'lib/utils'

const HeaderContent = ({ children }: { children: React.ReactNode }) => {
  const [config] = useConfig()
  const headerTheme = config.headerTheme !== 'light' && config.headerTheme !== 'transparent' ? ` dark theme-${config.headerTheme}` : `theme-${config.headerTheme}`
  if (config.sidebar === 'two-column') {
    return (
      <header className={cn('top-0 z-40', config.navbar, {
        'has-sticky-header sticky top-6  px-6 ': config.navbar === 'floating'
      })}>
        <div className={cn('flex-none   bg-header backdrop-blur-lg md:px-6 px-[15px] py-3    xl:ms-[300px] flex items-center justify-between  relative', headerTheme, {
          'xl:ms-[72px]': config.subMenu || !config.hasSubMenu,
          'border-b': config.skin === 'bordered' && config.layout !== 'semi-box',
          'xl:ms-0': config.menuHidden || config.layout === "horizontal",
          'border': config.skin === 'bordered' && config.layout === 'semi-box',
          'shadow-base': config.skin === 'default',
          'rounded-md': config.navbar === 'floating'


        })}>
          {children}
        </div>

      </header>
    )
  }

  // Sticky, lightly see-through bar across the content column (the sidebar sits beside it, not under it).
  return (
    <header className={cn('sticky top-0 z-40', headerTheme)}>
      <div className='flex h-16 items-center justify-between gap-3 border-b bg-header/80 px-4 backdrop-blur-lg md:px-8 lg:px-10'>
        {children}
      </div>
    </header>
  )
}

export default HeaderContent